/**
 * True when the asset's category is Real Estate (name match, case- and separator-insensitive).
 * @param {object | null | undefined} asset
 */
export function isRealEstateCategory(asset) {
  const name = asset?.assetCategory?.name;
  if (name == null || String(name).trim() === "") return false;
  const lower = String(name).trim().toLowerCase();
  const compact = lower.replace(/[\s_-]+/g, "");
  return compact === "realestate" || lower === "real estate" || lower.startsWith("real estate ");
}
